export default __webpack_public_path__ + "static/media/UL.54985662.png";